import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";

interface AnimatedCountProps {
  target: number;
}

export function AnimatedCount({ target }: AnimatedCountProps) {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.floor(latest));

  useEffect(() => {
    const controls = animate(count, target, { duration: 0.6 });
    return controls.stop;
  }, [target, count]);

  return <motion.span>{rounded}</motion.span>;
}
